import Highlight, {
    defaultProps as highlightDefaultProps,
    Language,
    PrismTheme,
} from "prism-react-renderer";
import React from "react";
import { useTheme } from "@mui/material";
import lightTheme from "prism-react-renderer/themes/vsLight";
import darkTheme from "prism-react-renderer/themes/vsDark";

type PureHighlighterProps = {
    code: string;
    languageMode: Language;
    theme?: PrismTheme;
};
export const pureHighligherFn = function (
    code: string,
    languageMode: Language = "jsx",
    theme?: PrismTheme
) {
    return (
        <PureHighlighter
            code={code}
            languageMode={languageMode}
            theme={theme}
        />
    );
};
export const PureHighlighter = ({
    code,
    languageMode = "jsx",
    theme,
}: PureHighlighterProps) => {
    const muiTheme = useTheme();
    const t = React.useMemo(() => {
        if (theme) {
            return theme;
        } else {
            if (muiTheme.palette.mode === "dark") {
                return {
                    ...darkTheme,
                    plain: {
                        ...darkTheme.plain,
                        backgroundColor: "inherit",
                    },
                };
            } else {
                return {
                    ...lightTheme,
                    plain: {
                        ...lightTheme.plain,
                        backgroundColor: "inherit",
                    },
                };
            }
        }
    }, [muiTheme.palette.mode, theme]);

    return (
        <Highlight
            {...highlightDefaultProps}
            theme={t}
            code={code}
            language={languageMode}
        >
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre
                    className={className}
                    style={{
                        maxWidth: "100%",
                        overflowX: "auto",
                        whiteSpace: "pre-wrap",
                        wordWrap: "break-word",
                        margin: "0",
                        ...style,
                    }}
                >
                    {tokens.map((line, i) => (
                        <div {...getLineProps({ line, key: i })}>
                            {line.map((token, key) => (
                                <span {...getTokenProps({ token, key })} />
                            ))}
                        </div>
                    ))}
                </pre>
            )}
        </Highlight>
    );
};
